var map = {
	"./CA.json": [
		2283,
		2283
	],
	"./GB.json": [
		45058
	],
	"./IE.json": [
		30401
	],
	"./US.json": [
		87055,
		7055
	],
	"./default.json": [
		17818
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4579;
module.exports = webpackAsyncContext;